import { FormattedMessage } from "react-intl";
import { Heading } from "@lendcord/concord";
import { ProfileField } from "@/features/profile/components/ProfileField";

// Mirrors BankAccountSection's own "has primary account" view-mode box (the
// more common case) so the loading footprint matches the most likely loaded
// shape — see docs/design-system.md's "Loading states" section.
export function BankAccountSectionSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <Heading level={3}>
        <FormattedMessage id="lender.profile.bankAccountDetailsHeading" />
      </Heading>
      <div className="rounded-md border border-border p-4">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <ProfileField labelId="lender.profile.bankNameLabel" value="" loading />
          <ProfileField labelId="lender.profile.accountTypeLabel" value="" loading />
          <ProfileField labelId="lender.profile.accountNumberLabel" value="" loading />
          <ProfileField labelId="lender.profile.ifscCodeLabel" value="" loading />
          <ProfileField labelId="lender.profile.accountHolderNameLabel" value="" loading />
        </div>
      </div>
    </div>
  );
}
